import { userSetupUserInformationStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupUserInformation";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

userSetupUserInformationStyles.title = {
    variant: "h5",
    css: css`
        font-weight: 700;
        color: ${getColor("text.main")};
    `,
};
userSetupUserInformationStyles.wrapper = {
    css: css`
        padding-bottom: 15px;
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")};
            }
        }
    `,
};
